function buildLabelCadastroAdicional(c) {
  return c.codigoInterno ? `${c.codigoInterno} - ${c.descricao}` : c.descricao;
}

// eslint-disable-next-line import/prefer-default-export
export const cadastrosAdicionaisToMap = (cadastrosAdicionais) => {
  const map = {};
  cadastrosAdicionais.forEach((c) => {
    map[c.tipo] = buildLabelCadastroAdicional(c);
  });
  return map;
};
